import { getStoreBuilder } from '@codegrade/vuex-typex';
import client from '@/client';
import * as utils from '@/utils';
const storeBuilder = getStoreBuilder();
/** @returns Fresh initial state. */
function makeInitialState() {
    return { rules: undefined };
}
const moduleBuilder = storeBuilder.module('registrationDomains', makeInitialState());
/** The Registration Domains store module. */
export var RegistrationDomainsStore;
(function (RegistrationDomainsStore) {
    const commitData = moduleBuilder.commit((state, data) => {
        state.rules = data;
    }, 'commitData');
    const commitClear = moduleBuilder.commit(state => {
        Object.assign(state, makeInitialState());
    }, 'commitClear');
    /** Get the paginated registration domain rules. */
    RegistrationDomainsStore.getRegistrationDomains = moduleBuilder.read((state) => utils.getPaginatedState(state.rules), 'getRegistrationDomains');
    /** Load registration domain rules. */
    RegistrationDomainsStore.loadRegistrationDomains = moduleBuilder.dispatch(async ({ state }, { toLoad, }) => {
        await utils.loadPaginatedWithForce({
            getData: () => state.rules,
            commitData,
            load: async (nextToken) => await client.p.registrationDomain.getAll({ nextToken }),
            toLoad,
        });
    }, 'loadRegistrationDomains');
    /** Create a new registration domain rule. */
    RegistrationDomainsStore.createRegistrationDomain = moduleBuilder.dispatch(async ({ state }, { data, }) => {
        const response = await client.p.registrationDomain.create({
            requestBody: data,
        });
        const rule = response.cgResult;
        const existing = state.rules;
        if (existing?.data != null) {
            commitData({
                ...existing,
                data: [...existing.data, rule],
            });
        }
        return rule;
    }, 'createRegistrationDomain');
    /** Update an existing registration domain rule by ID. */
    RegistrationDomainsStore.patchRegistrationDomain = moduleBuilder.dispatch(async ({ state }, { domainId, data, }) => {
        const response = await client.p.registrationDomain.patch({
            domainId,
            requestBody: data,
        });
        const rule = response.cgResult;
        const existing = state.rules;
        if (existing?.data != null) {
            const idx = existing.data.findIndex(r => r.id === rule.id);
            if (idx >= 0) {
                const updated = [...existing.data];
                updated[idx] = rule;
                commitData({ ...existing, data: updated });
            }
        }
        return rule;
    }, 'patchRegistrationDomain');
    /** Delete a registration domain rule by ID and remove it from the store. */
    RegistrationDomainsStore.deleteRegistrationDomain = moduleBuilder.dispatch(async ({ state }, { domainId, }) => {
        await client.p.registrationDomain.delete({ domainId });
        const existing = state.rules;
        if (existing?.data != null) {
            commitData({
                ...existing,
                data: existing.data.filter(r => r.id !== domainId),
            });
        }
    }, 'deleteRegistrationDomain');
    utils.signal.AFTER_USER_CHANGED.registerSync(() => {
        commitClear();
    });
})(RegistrationDomainsStore || (RegistrationDomainsStore = {}));
